<template>
  <div class="editor-panel__row">
    <span class="editor-panel__row-label">{{ label }}</span>
    <div class="editor-panel__row-field">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditorRowGroup',
  props: {
    label: { type: String, required: true }
  }
}
</script>

<style scoped>
@import '../editor-panel.css';
</style>
